import { createServerFn } from '@tanstack/react-start'

const BUILD_SHA = process.env.VERCEL_GIT_COMMIT_SHA ?? 'dev'

export const getBuildSha = createServerFn({ method: 'GET' }).handler(async () => {
  return { sha: BUILD_SHA }
})
